// ACTA_AGENT_ACTION_PLANNER_V2
//
// Le futur LLM devra produire uniquement
// des ids déclarés dans le registre.
// Aucun plan ne peut inventer une API.

import {
  availableAgentActions,
  availableAgentToolContracts,
} from "@/agent/actionRegistry";

import {
  validateAgentActionInput,
} from "@/agent/actionRuntimeContract";

import {
  validateAgentPlanShape,
} from "@/agent/actionContract";

export function validateAgentPlan({
  plan,
  user,
  hasFeature,
}) {
  const shape =
    validateAgentPlanShape(
      plan
    );

  if (!shape.valid) {
    return shape;
  }

  const available =
    availableAgentActions({
      user,
      hasFeature,
    });

  const byId =
    new Map(
      available.map(
        (action) => [
          action.id,
          action,
        ]
      )
    );

  const unavailable =
    plan.actions.find(
      (step) =>
        !byId.has(step.id)
    );

  if (unavailable) {
    return {
      valid: false,
      error:
        `Action indisponible : ${unavailable.id}`,
    };
  }

  return {
    valid: true,
    error: "",
    actions:
      plan.actions.map(
        (step) => ({
          ...step,
          action:
            byId.get(
              step.id
            ),
        })
      ),
  };
}


// ACTA_AGENT_STRUCTURED_PLAN_V4
export function validateAgentStructuredPlan({plan,user,hasFeature}) {
  const shape=validateAgentPlanShape(plan);
  if(!shape.valid) return {...shape,ready:false,issues:[],actions:[]};
  const byId=new Map(availableAgentToolContracts({user,hasFeature}).map(c=>[c.id,c]));
  const actions=[]; const issues=[];
  for(const step of plan.actions){
    const contract=byId.get(step.id);
    if(!contract) return {valid:false,ready:false,error:`Action indisponible : ${step.id}`,issues:[],actions:[]};
    const params=step.params&&typeof step.params==="object"&&!Array.isArray(step.params)?step.params:{};
    const input=validateAgentActionInput(contract,params);
    if(!input.valid) issues.push({id:contract.id,type:input.error?"not_ready":"missing_or_invalid_input",missing:input.missing,invalid:input.invalid,unknown:input.unknown,error:input.error});
    actions.push({...step,params,action:contract,input});
  }
  return {valid:true,ready:issues.length===0,error:"",issues,actions};
}
